import React, { useEffect } from 'react';
import { Form, Button, DatePicker, Input, InputNumber } from 'antd';
import { formatDate, getDisabledDates } from 'utils';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import dayjs from 'dayjs';

function BusinessTripForm({ initialValues, disableDate, onSubmit, children }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      const { worker_id, begin_date, end_date, reason, amount } = initialValues;

      const reasonFields = reason
        .split('. ')
        .map((item) => item.slice(item.indexOf(':') + 2));

      form.setFieldsValue({
        worker_id,
        date: [dayjs(begin_date), dayjs(end_date)],
        amount,
        destination: reasonFields[0],
        company: reasonFields[1],
        basis: reasonFields[2],
        purpose: reasonFields[3],
      });
    }
  }, [initialValues]);

  const handleSubmit = async (values) => {
    const [begin, end] = values.date;

    const payload = {
      ...values,
      begin_date: formatDate(begin, 'YYYY-MM-DD'),
      end_date: formatDate(end, 'YYYY-MM-DD'),
      reason: `Место назначения: ${values?.destination}. Организация: ${values?.company}. Основание: ${values?.basis}. Цель: ${values?.purpose}`,
    };

    delete payload.date;
    delete payload.destination;
    delete payload.company;
    delete payload.basis;
    delete payload.purpose;

    const isSubmitted = await onSubmit(payload);

    if (isSubmitted) {
      form.resetFields();
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="horizontal"
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      labelAlign="right"
    >
      {children}

      <Form.Item
        name="date"
        label="Дата начала и окончания"
        rules={[requiredRule]}
      >
        <DatePicker.RangePicker
          format="DD.MM.YYYY"
          allowClear
          disabledDate={getDisabledDates(disableDate)}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item
        name="amount"
        label="Суточные (за 1 день)"
        rules={[requiredRule]}
      >
        <InputNumber
          addonAfter="KZT"
          controls={false}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
          }
          placeholder="Введите сумму"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item
        name="destination"
        label="Место назначение"
        rules={[requiredRule]}
      >
        <Input placeholder="Введите место назначения (город)" allowClear />
      </Form.Item>

      <Form.Item name="company" label="Организация" rules={[requiredRule]}>
        <Input
          placeholder="Введите место назначение (организация)"
          allowClear
        />
      </Form.Item>

      <Form.Item name="basis" label="Основание" rules={[requiredRule]}>
        <Input placeholder="Введите основание (Приказ)" allowClear />
      </Form.Item>

      <Form.Item name="purpose" label="Цель" rules={[requiredRule]}>
        <Input placeholder="Введите цель поездки" allowClear />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit">
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  );
}

export { BusinessTripForm };
